import { useHistory } from 'react-router-dom';

export type TabPathsType = 'teams' | 'branches';

export const useGetTabPath = () => {
  const history = useHistory();
  const paths = {
    teams: 'teams',
    branches: 'branches',
  };

  return (path: TabPathsType, key: string) =>
    history.push(`/users/${key}/${paths[path] || 'branches'}`);
};
